import styled from 'styled-components';
import Button from '../../../../../../components/Button';

export const CreateExtraBtn = styled(Button)`
  align-self: center;
`;
export const CopyPasteButtonContainer = styled.div`
  display: flex;
`;

export const Spacer = styled.div`
  width: 14px;
`;
